export const AUDIO_LOAD_TIMEOUT = 10000

// Generation + canonical source checks make events from an aborted media request harmless.
// The controller owns DOM listeners; this object owns the race and timeout contract.
export class AudioLoadState {
  constructor({ onLoading, onReady, onFailure, timeout = AUDIO_LOAD_TIMEOUT,
                timers = globalThis, baseURL = "http://localhost/" }) {
    this.onLoading = onLoading
    this.onReady = onReady
    this.onFailure = onFailure
    this.timeout = timeout
    this.timers = timers
    this.baseURL = baseURL
    this.generation = 0
    this.timer = null
  }

  start(src) {
    this.cancel()
    const generation = this.generation
    this.src = this.#canonical(src)
    this.pending = true
    this.onLoading()
    this.timer = this.timers.setTimeout(() => this.fail(generation, this.src, "timeout"),
                                        this.timeout)
    return generation
  }

  ready(generation, currentSrc) {
    if (!this.pending || !this.#accepts(generation, currentSrc)) return false

    this.pending = false
    this.#clearTimer()
    this.onReady()
    return true
  }

  fail(generation, currentSrc, reason = "error") {
    if (!this.#accepts(generation, currentSrc)) return false

    this.pending = false
    this.#clearTimer()
    this.onFailure(reason)
    return true
  }

  cancel() {
    this.generation += 1
    this.pending = false
    this.#clearTimer()
  }

  #accepts(generation, currentSrc) {
    if (generation !== this.generation) return false

    return this.#canonical(currentSrc) === this.src
  }

  #canonical(src) {
    return new URL(src, this.baseURL).href
  }

  #clearTimer() {
    if (this.timer !== null) this.timers.clearTimeout(this.timer)
    this.timer = null
  }
}
